import { parse } from 'cookie';

export function getRcxGlobalCookieValue(documentCookie: string): string {
	const { rcxGlobal } = parse(documentCookie);

	if (typeof rcxGlobal === 'undefined') {
		return '';
	}

	return rcxGlobal;
}

export function getNativeRcxGlobalCookie(): string {
	return getRcxGlobalCookieValue(document.cookie);
}
